import script from "./ListView.vue?vue&type=script&setup=true&lang=js"
export * from "./ListView.vue?vue&type=script&setup=true&lang=js"

import "./ListView.vue?vue&type=style&index=0&id=c2ca904c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2ca904c"]])

export default __exports__